import React, { Component } from 'react';

import  './header.css';

class Header extends Component {
    render() {
        return (
            <section class="category_banner">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 category_bannertext">
                            <h1>Contact Us</h1>
                            <p></p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }


}


export default Header;


// WEBPACK FOOTER //
// ./src/contact/header/header.js